import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import RoutesWapper from "./routes/Index.routes";
import ThemeProvider from "./theme";
import "../src/assets/scss/style.scss";

function App() {

  const Root = () => {
    return <RoutesWapper />;
  };

  return (
    <ThemeProvider>
      <BrowserRouter>
        <Root />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
